export enum ApiKeyScope {
  ROBOTS_READ = 'robots:read',
  MISSIONS_READ = 'missions:read',
  VERSIONS_WRITE = 'versions:write',
  ROBOTS_PROVISION = 'robots:provision',
}

export const API_KEY_SCOPES: ApiKeyScope[] = Object.values(ApiKeyScope);
export const MANUFACTURER_ONLY_SCOPES: ApiKeyScope[] = [
  ApiKeyScope.VERSIONS_WRITE,
  ApiKeyScope.ROBOTS_PROVISION,
];

interface ExternalApi {
  id: string;
  name: string;
  prefix: string;
  scopes: ApiKeyScope[];
  dateCreated: string;
  dateExpires: string;
  organizationId: string;
  apiKey?: string;
}

export interface PostApiKey {
  organizationId: string;
  name: string;
  scopes: ApiKeyScope[];
}

export default ExternalApi;

// mock data

export const mockExternalApi = {
  id: 'f22b3fe7-a267-4152-a678-155717d138b4',
  name: 'Factory provisioning',
  prefix: 'j8uQ1Lnj',
  scopes: ['robots:read'],
  dateCreated: '2025-03-08T00:00:00',
  dateExpires: '2025-09-08T00:00:00',
  organizationId: 'b1f8a5a1-3f1e-4b53-9f0a-2f4c9c1d7a11',
} as ExternalApi;
